import { z } from 'zod';
import { idempotency } from './spine';

const uuid = z.string().uuid();
const quantityHundredths = z.number().int().positive().max(100_000_000);
export const itemAvailabilityInput = z
  .object({ itemId: uuid, locationId: uuid.optional() })
  .strict();
export type ItemAvailabilityInput = z.infer<typeof itemAvailabilityInput>;
export const itemMonthlyAvailabilityInput = z
  .object({
    itemId: uuid,
    locationId: uuid.optional(),
    year: z.number().int().min(1900).max(2200).optional(),
  })
  .strict();
export type ItemMonthlyAvailabilityInput = z.infer<typeof itemMonthlyAvailabilityInput>;
export interface ItemAvailabilityMonth {
  month: string;
  phase: 'actual' | 'current' | 'projected';
  openingPhysicalHundredths: number | null;
  closingPhysicalHundredths: number | null;
  recordedUseHundredths: number | null;
  billedQuantityHundredths: number | null;
  billedRevenueCents: number | null;
  closingReservedHundredths: number | null;
  scheduledDemandHundredths: number;
  scheduledReservedHundredths: number;
  expectedIncomingHundredths: number;
  draftIncomingHundredths: number;
  projectedClosingPhysicalHundredths: number | null;
  quoteDemandHundredths: null;
}
export const transferChoicesInput = z
  .object({ itemId: uuid, fromLocationId: uuid })
  .strict();
export const reallocateWorkOrderLineInput = idempotency
  .extend({
    workOrderLineId: uuid,
    sourceLocationId: uuid,
    reason: z.string().trim().min(1).max(500),
    expectedVersion: z.number().int().positive(),
  })
  .strict();
export type ReallocateWorkOrderLineInput = z.infer<typeof reallocateWorkOrderLineInput>;
export const workOrderAllocationsInput = z.object({ workOrderId: uuid }).strict();
export type WorkOrderAllocationsInput = z.infer<typeof workOrderAllocationsInput>;
export const reserveWorkOrderInput = idempotency.extend({ workOrderId: uuid }).strict();
export type ReserveWorkOrderInput = z.infer<typeof reserveWorkOrderInput>;
export const linkBackorderSupplyInput = idempotency
  .extend({ workOrderLineId: uuid, purchaseOrderLineId: uuid, quantityHundredths })
  .strict();
export type LinkBackorderSupplyInput = z.infer<typeof linkBackorderSupplyInput>;
export const releaseSupplyLinkInput = idempotency
  .extend({ supplyLinkId: uuid, reason: z.string().trim().min(1).max(500) })
  .strict();
export type ReleaseSupplyLinkInput = z.infer<typeof releaseSupplyLinkInput>;
export const createBackorderPurchaseOrderInput = idempotency
  .extend({
    workOrderLineId: uuid,
    vendorId: uuid,
    expectedReceiptLocationId: uuid.optional(),
    quantityHundredths: quantityHundredths.optional(),
  })
  .strict();
export type CreateBackorderPurchaseOrderInput = z.infer<
  typeof createBackorderPurchaseOrderInput
>;
